import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query';

import { useServiceError } from '@/hooks';

import {
  CreateWorkOrderItemTagRequest,
  ListWorkOrderItemTagsQuery,
  UpdateWorkOrderItemTagRequest,
} from './WorkOrderItemTags.types';

import {
  listWorkOrderItemTags,
  deleteWorkOrderItemTag,
  createWorkOrderItemTag,
  updateWorkOrderItemTag,
} from './WorkOrderItemTags.service';

import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';

export function useWorkOrderItemTags(params?: ListWorkOrderItemTagsQuery) {
  const query = useInfiniteQuery(
    ['workOrderItemTags', { ...params }],
    ({ pageParam }) => {
      const req: ListWorkOrderItemTagsQuery = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listWorkOrderItemTags(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useCreateWorkOrderItemTag() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: CreateWorkOrderItemTagRequest) => createWorkOrderItemTag(obj),
    {
      onSuccess() {
        queryClient.invalidateQueries(['workOrderItemTags']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useUpdateWorkOrderItemTag() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: UpdateWorkOrderItemTagRequest) => updateWorkOrderItemTag(obj),
    {
      onSuccess() {
        queryClient.invalidateQueries(['workOrderItemTags']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useDeleteWorkOrderItemTag() {
  const queryClient = useQueryClient();

  const mutation = useMutation((id: number) => deleteWorkOrderItemTag(id), {
    onSuccess() {
      queryClient.invalidateQueries(['workOrderItemTags']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}
